import React, { useState } from 'react';
import './home.css';

const Home = () => {
  const [showPackageForm, setShowPackageForm] = useState(false);
  const [showCTAForm, setShowCTAForm] = useState(false);

  const handlePackageSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);

    await fetch("https://formsubmit.co/ajax/info@wecanserve.com", {
      method: "POST",
      body: data
    });

    setShowPackageForm(false);
    alert("Thanks! We'll get back to you with the right growth plan.");
  };

  const handleCTASubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);

    await fetch("https://formsubmit.co/ajax/info@wecanserve.com", {
      method: "POST",
      body: data
    });

    setShowCTAForm(false);
    alert("Thanks! We'll get back to you.");
  };

  const serviceData = [
    {
      title: "Revenue Growth",
      desc: "Strategies designed to consistently increase your revenue with measurable, long-term results.",
      icon: "/icons/revenue.png"
    },
    {
      title: "Brand Dominance",
      desc: "Position your brand as the obvious choice in your market and stay ahead of competitors.",
      icon: "/icons/branding.png"
    },
    {
      title: "Personal Branding",
      desc: "Build a strong personal brand that drives trust, authority, and high-value opportunities.",
      icon: "/icons/personal.png"
    },
    {
      title: "Media Visibility",
      desc: "Expand your reach and credibility by getting your brand seen across the right platforms.",
      icon: "/icons/media.png"
    },
    {
      title: "Customer Acquisition",
      desc: "Attract high-quality customers consistently with proven, data-driven growth strategies.",
      icon: "/icons/seo.png"
    },
    {
      title: "Higher Conversions",
      desc: "Turn more visitors into paying customers with optimized funnels and clear messaging.",
      icon: "/icons/conversion.png"
    },
    {
      title: "Premium Positioning",
      desc: "Position your brand to command higher pricing and attract better, more serious clients.",
      icon: "/icons/premium.png"
    },
    {
      title: "Scalable Systems",
      desc: "Build systems that allow your business to grow efficiently without constant manual effort.",
      icon: "/icons/system.png"
    }
  ];

  const portfolioData = [
    {
      client: "YouWeCan",
      category: "Offline Event",
      stat: "Created a high-impact youth engagement model",
      img: "/home-ywc.png"
    },
    {
      client: "Mudras Against Cancer",
      category: "Interview | Editorial Feature",
      stat: "Build credibility through strategic media exposures",
      img: "/home-interview1.png"
    },
    {
      client: "Zuvius Lifesciences",
      category: "Digital Marketing",
      stat: "10x growth in online presence",
      img: "/home-digital.png"
    }
  ];

  return (
    <div className="home-container">
      {/* --- SECTION 1: HERO --- */}
      <section className="hero-section">
        <div className="hero-text">
          <div className="hero-badge">Powered by Marketing , Accelerated by AI</div>

          <h1>
            WeCanServe isn’t just a company — <span>It’s your growth partner.</span>
          </h1>

          <div className="hero-actions">
            <a href="/portfolio" className="btn-outline">
              View Our Work <span className="play">▶</span>
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <img
            src="/hero-image.png"
            alt="WeCanServe Digital Marketing Mockup"
            className="mockup-img"
          />
        </div>
      </section>

      {/* --- SECTION 2: WHAT WE DO --- */}
      <section className="services-section">
        <h2 className="section-title">What Are You Looking For?</h2>

        <div className="slider-container">
          <div className="slider-track">
            {serviceData.map((item, index) => (
              <div className="service-card" key={`first-${index}`}>
                <div className="icon-box">
                  <img src={item.icon} alt={item.title} />
                </div>

                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <div className="card-footer-arrow">→</div>
              </div>
            ))}

            {serviceData.map((item, index) => (
              <div className="service-card" key={`second-${index}`}>
                <div className="icon-box">
                  <img src={item.icon} alt={item.title} />
                </div>

                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <div className="card-footer-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- SECTION 3: PACKAGES --- */}
      <section className="packages-section">
        <h2 className="section-title">Choose Your Growth Path</h2>

        <p className="section-subtitle">
          Different stages demand different moves.
          We build what your business needs — right now and next
        </p>

        <div className="packages-grid">
          <div className="package-card">
            <div className="card-inner">
              <div className="card-front blue">
                <img src="/launch-engine.png" alt="Launch Engine" />
                <h3>Launch Engine</h3>
              </div>

              <div className="card-back blue">
                <h3>Launch Engine</h3>
                <p>For new or early-stage brands</p>
                <ul>
                  <li>Website Development</li>
                  <li>Brand Identity Setup</li>
                  <li>SEO Foundation</li>
                  <li>Social Media Setup</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="package-card">
            <div className="card-inner">
              <div className="card-front green">
                <img src="/growth-accelerator.png" alt="Growth Accelerator" />
                <h3>Growth Accelerator</h3>
              </div>

              <div className="card-back green">
                <h3>Growth Accelerator</h3>
                <p>For businesses ready to scale</p>
                <ul>
                  <li>Conversion-Focused Website</li>
                  <li>Paid Ads Strategy</li>
                  <li>SEO + Content System</li>
                  <li>Analytics Setup</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="package-card">
            <div className="card-inner">
              <div className="card-front red">
                <img src="/scale-system.png" alt="Scale System" />
                <h3>Scale System</h3>
              </div>

              <div className="card-back red">
                <h3>Scale System</h3>
                <p>For brands focused on revenue growth</p>
                <ul>
                  <li>Full Funnel Optimization</li>
                  <li>Performance Marketing</li>
                  <li>Advanced SEO</li>
                  <li>Conversion Tracking</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="package-card">
            <div className="card-inner">
              <div className="card-front yellow">
                <img src="/auth-builder.png" alt="Authority Builder" />
                <h3>Authority Builder</h3>
              </div>

              <div className="card-back yellow">
                <h3>Authority Builder</h3>
                <p>For brands building long-term trust</p>
                <ul>
                  <li>Personal Branding</li>
                  <li>Content Strategy</li>
                  <li>Social Media Growth</li>
                  <li>Reputation Management</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="growth-plan-content">
          <button
            className="custom-package-btn"
            onClick={() => setShowPackageForm(true)}
          >
            Explore Your Growth Plan →
          </button>
        </div>
      </section>

      {/* --- CTA SECTION --- */}
      <section className="revenue-cta-section">
        <div className="cta-banner">
          <div className="cta-content">
            <h2>
              Is your digital presence just being <span>seen </span>— <br />
              or is it actually <span>bringing in revenue?</span>
            </h2>

            <p>If not, that’s a serious gap in your business.</p>

            <button
              className="btn-yellow"
              onClick={() => setShowCTAForm(true)}
            >
              Let’s Fix It <span className="arrow">→</span>
            </button>
          </div>

          <div className="cta-visual">
            <img src="/cta-section.png" alt="Revenue Growth Graph" />
          </div>
        </div>
      </section>

      {/* --- FEATURED WORK --- */}
      <section className="portfolio-section">
        <div className="portfolio-header">
          <div>
            <h2 className="section-title">Featured Work</h2>
          </div>

          <a href="/portfolio" className="view-all">
            View All Projects →
          </a>
        </div>

        <div className="portfolio-grid">
          {portfolioData.map((project, index) => (
            <div className="portfolio-card" key={index}>
              <div className="card-image">
                <img src={project.img} alt={project.client} />
              </div>

              <div className="card-info">
                <div className="card-title-row">
                  <h3>{project.client}</h3>

                  <div
                    className="external-link"
                    onClick={() => {
                      if (project.client === "YouWeCan") {
                        window.location.href = "/events/you-we-can-campaign";
                      } else if (project.client === "Mudras Against Cancer") {
                        window.location.href = "/portfolio/mudras-against-cancer";
                      } else if (project.client === "Zuvius Lifesciences") {
                        window.location.href = "/digital-marketing/zuvius-lifesciences";
                      }
                    }}
                  >
                    ↗
                  </div>
                </div>

                <p className="category">{project.category}</p>
                <p className="stat-highlight">{project.stat}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- GROWTH PLAN MODAL --- */}
      {showPackageForm && (
        <div
          className="modal-overlay"
          onClick={() => setShowPackageForm(false)}
        >
          <div
            className="modal-box package-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Let’s Build The Right Growth Plan For Your Brand</h3>

              <span
                className="close-btn"
                onClick={() => setShowPackageForm(false)}
              >
                ✕
              </span>
            </div>

            <form onSubmit={handlePackageSubmit} className="modal-form">
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="form_type" value="Growth Plan Inquiry" />

              <input type="text" name="name" placeholder="Full Name" required />
              <input type="tel" name="phone" placeholder="Mobile Number" required />
              <input type="email" name="email" placeholder="Email Address" required />
              <input type="text" name="brand_name" placeholder="Brand / Company Name" />

              <select name="business_stage" required>
                <option value="">Current Business Stage</option>
                <option value="New Brand / Startup">New Brand / Startup</option>
                <option value="Growing Brand">Growing Brand</option>
                <option value="Established Brand">Established Brand</option>
                <option value="Personal Brand">Personal Brand</option>
              </select>

              <select name="growth_plan" required>
                <option value="">Which growth plan are you interested in?</option>
                <option value="Launch Engine">Launch Engine</option>
                <option value="Growth Accelerator">Growth Accelerator</option>
                <option value="Scale System">Scale System</option>
                <option value="Authority Builder">Authority Builder</option>
                <option value="Customized Growth Plan">Customized Growth Plan</option>
              </select>

              <textarea
                name="message"
                placeholder="Tell us about your business goals, what services you're looking for, or what challenges you're currently facing..."
                required
              />

              <button type="submit" className="btn-send">
                Submit Growth Plan Request →
              </button>
            </form>
          </div>
        </div>
      )}

      {/* --- CTA CONSULTATION MODAL --- */}
      {showCTAForm && (
        <div
          className="modal-overlay"
          onClick={() => setShowCTAForm(false)}
        >
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Start a Conversation</h3>

              <span
                className="close-btn"
                onClick={() => setShowCTAForm(false)}
              >
                ✕
              </span>
            </div>

            <form onSubmit={handleCTASubmit} className="modal-form">
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="form_type" value="CTA Consultation Inquiry" />

              <input type="text" name="name" placeholder="Full Name" required />
              <input type="tel" name="phone" placeholder="Mobile Number (Optional)" />
              <input type="email" name="email" placeholder="Email Address" required />

              <select name="service" required>
                <option value="">Interested Service</option>
                <option value="Website Development">Website Development</option>
                <option value="Social Media Marketing">Social Media Marketing</option>
                <option value="Performance Marketing">Performance Marketing</option>
                <option value="SEO Services">SEO Services</option>
                <option value="Branding & Positioning">Branding & Positioning</option>
                <option value="Content Creation">Content Creation</option>
                <option value="PR & Media Coverage">PR & Media Coverage</option>
                <option value="AI Automation Solutions">AI Automation Solutions</option>
                <option value="Other">Other</option>
              </select>

              <textarea
                name="message"
                placeholder="Tell us about your requirement..."
                required
              />

              <button type="submit" className="btn-send">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;